import React from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import {useTranslation} from "react-i18next";
import {DialogTitle} from "@material-ui/core";
import withWidth, {WithWidthProps} from '@material-ui/core/withWidth';
import {COOKIE_KEYS, getCookieValue, setCookie} from '../../utils/CookieUtils';
import {DESKTOP_LOGIN_LINKS} from "../../constants/Links";
import {getDomain} from "../../api/BackendRestClient";


export const DesktopFallbackDialog: React.FC<WithWidthProps> = ({width}) => {

    const mobile = width === "xs";
    const {t} = useTranslation();


    const [mobileView, setMobileView] = React.useState(mobile || !!getCookieValue(COOKIE_KEYS.DESKTOP_FALLBACK));

    const useMobile = () => {
        setCookie(COOKIE_KEYS.DESKTOP_FALLBACK, true);
        setMobileView(true);
    };

    if (mobileView) {
        return null;
    }

    return (
        <Dialog
            maxWidth="sm"
            open={true}
            aria-labelledby="responsive-dialog-title"
        >

            <DialogTitle id="fallback-dialog-title">{t("core.fallback")}</DialogTitle>


            <DialogActions style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>
                <Button
                    href={DESKTOP_LOGIN_LINKS[getDomain()]}
                    variant="contained" size="small">
                    {t("buttons.switch-to-desktop")}
                </Button>

                <Button
                    onClick={useMobile}
                    color="primary" variant="contained" size="small">
                    {t("buttons.continue-mobile")}
                </Button>
            </DialogActions>
        </Dialog>

    );
};

export default withWidth()(DesktopFallbackDialog);